import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { putPaymentRequest } from '@src/api'
import { DefaultApiPutPaymentRequestRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'
import { CustomError } from '@src/types'

export const useUpdatePaymentRequest = () => {
  const { axiosInstance } = useAxios()

  return useMutation<
    unknown,
    AxiosResponse<CustomError>,
    DefaultApiPutPaymentRequestRequest
  >({
    mutationFn: (params: DefaultApiPutPaymentRequestRequest) =>
      putPaymentRequest(axiosInstance, params),
  })
}
